import PropTypes from "prop-types"

// material-ui
import { styled } from "@mui/material/styles"
import AppBar from "@mui/material/AppBar"

// project import
import { drawerWidth } from "src/configs/themeConfig"

// ==============================|| HEADER - APP BAR STYLED ||============================== //

const AppBarStyled = styled(AppBar, { shouldForwardProp: prop => prop !== "open" })(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer - 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  ...(!open && {
    background: "transparent",
    width: `100%`
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `100%`,
    background: "transparent",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  })
}))

AppBarStyled.propTypes = {
  open: PropTypes.bool
}

export default AppBarStyled
